'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.fetchBlockedSchemes = fetchBlockedSchemes;
exports.fetchPaymentMethods = fetchPaymentMethods;
exports.reinitialiseForm = reinitialiseForm;
exports.onFetchPmtFailed = onFetchPmtFailed;
exports.watchFetchPmtMethods = watchFetchPmtMethods;
exports.watchFetchPmtMethodsSucceded = watchFetchPmtMethodsSucceded;
exports.watchFetchPmtMethodsFailed = watchFetchPmtMethodsFailed;

var _messageBus = require('@wh/message-bus');

var _immutable = require('redux-form/immutable');

var _effects = require('redux-saga/effects');

var _reduxSaga = require('redux-saga');

var _quickDepositLogic = require('@wh/quick-deposit-logic');

var _constants = require('../../constants');

var _creditCardsBan = require('../../config/creditCardsBan');

var _filterBannedCreditCards = require('../../utils/filterBannedCreditCards');

var _filterBannedCreditCards2 = _interopRequireDefault(_filterBannedCreditCards);

var _actions = require('../../actions');

var _events = require('../../events');

var _selectors = require('../../selectors');

var _analytics = require('../../analytics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchBlockedSchemes),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(fetchPaymentMethods),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(reinitialiseForm),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(onFetchPmtFailed),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(watchFetchPmtMethods),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(watchFetchPmtMethodsSucceded),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(watchFetchPmtMethodsFailed);
//compatibility to versions up to 0.15 of redux-sage


var takeEveryEffect = _effects.takeEvery || _reduxSaga.takeEvery;

function fetchBlockedSchemes() {
  var _ref, blockedSchemesUrl, blockedSchemesResponse, blockedSchemesData;

  return _regenerator2.default.wrap(function fetchBlockedSchemes$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_selectors.configSelector);

        case 2:
          _ref = _context.sent;
          blockedSchemesUrl = _ref.blockedSchemesUrl;
          _context.prev = 4;
          _context.next = 7;
          return (0, _effects.call)(fetch, blockedSchemesUrl);

        case 7:
          blockedSchemesResponse = _context.sent;
          _context.next = 10;
          return (0, _effects.call)([blockedSchemesResponse, 'json']);

        case 10:
          blockedSchemesData = _context.sent;
          return _context.abrupt('return', blockedSchemesData.configs[0].blockedSchemes.map(function (schemeData) {
            return schemeData['scheme'];
          }));

        case 14:
          _context.prev = 14;
          _context.t0 = _context['catch'](4);
          return _context.abrupt('return', _creditCardsBan.blockedSchemesFallback);

        case 17:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[4, 14]]);
}

var applePayAvailability = function applePayAvailability(obPmtApiInstance) {
  return obPmtApiInstance.paymentMethods && obPmtApiInstance.paymentMethods.apayCompatibleDevice && obPmtApiInstance.paymentMethods.apayHasActiveCardPromise && obPmtApiInstance.paymentMethods.lastActiveMethod === 'APAY';
};

function fetchPaymentMethods() {
  var configObj, pmtApi, _ref2, currencyCode, countryCode, creditCardDepBlocked, paymentMethods, isApplePayAvailable, blockedSchemes, filteredCardMethods, paymentMethod, paymentData, isDefaultCardChanged, activeCardMethod, _paymentData;

  return _regenerator2.default.wrap(function fetchPaymentMethods$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.select)(_selectors.configSelector);

        case 3:
          configObj = _context2.sent;
          pmtApi = new _quickDepositLogic.PaymentsApi({
            obURL: configObj.obUrl,
            disableApplePay: configObj.disableApplePay,
            overrideCache: true
          });
          _context2.next = 7;
          return (0, _effects.call)(function () {
            return pmtApi.initPaymentsAPI();
          });

        case 7:
          _ref2 = _context2.sent;
          currencyCode = _ref2.ccy_code;
          countryCode = _ref2.cntry_code;
          creditCardDepBlocked = _ref2.credit_card_dep_blocked;

          if (!(!currencyCode || !countryCode || !!creditCardDepBlocked)) {
            _context2.next = 16;
            break;
          }

          _context2.next = 14;
          return (0, _effects.put)((0, _actions.fetchPmtMethodsFailed)((0, _quickDepositLogic.uniformError)('APP_QD_ERR_NO_PMT_METHODS')));

        case 14:
          _context2.next = 53;
          break;

        case 16:
          _context2.next = 18;
          return (0, _effects.call)(function () {
            return pmtApi.getCustPaymentMethods();
          });

        case 18:
          paymentMethods = _context2.sent;
          // this throws error if no .cardMethods need to check if apple pay available earlier
          isApplePayAvailable = applePayAvailability(pmtApi.obPmtApiInstance) && !configObj.disableApplePay;
          _context2.next = 22;
          return (0, _effects.put)((0, _actions.setApplePayAvailability)(isApplePayAvailable));

        case 22:
          _context2.next = 24;
          return (0, _effects.call)(function () {
            return fetchBlockedSchemes();
          });

        case 24:
          blockedSchemes = _context2.sent;
          filteredCardMethods = (0, _filterBannedCreditCards2.default)(paymentMethods, blockedSchemes, countryCode);

          if (!isApplePayAvailable) {
            _context2.next = 39;
            break;
          }

          paymentMethod = paymentMethods.registeredMethods[0];
          paymentData = { currencyCode: currencyCode, countryCode: countryCode, isDefaultCardChanged: true };
          // add validation for Apple Pay because it is not supported by OB_PMT_API.js

          paymentMethod.addFieldValidation('amount', 'min_amount', parseFloat(paymentMethod.info.validation.minDepAmt));
          paymentMethod.addFieldValidation('amount', 'max_amount', parseFloat(paymentMethod.info.validation.maxDepAmt));
          _context2.next = 33;
          return (0, _effects.put)((0, _actions.fetchPmtMethodsSucceded)(paymentMethod, paymentData));

        case 33:
          _context2.next = 35;
          return (0, _effects.put)((0, _actions.trackEvent)(_analytics.MESSAGE_TRACKING_QD_OPEN));

        case 35:
          _context2.next = 37;
          return (0, _messageBus.publish)(_events.MESSAGE_SUB_QD_OPENED, {});

        case 37:
          _context2.next = 53;
          break;

        case 39:
          if (!(filteredCardMethods.activeCardMethods.length === 0)) {
            _context2.next = 44;
            break;
          }

          _context2.next = 42;
          return (0, _effects.put)((0, _actions.fetchPmtMethodsFailed)((0, _quickDepositLogic.uniformError)('APP_QD_ERR_NO_PMT_METHODS')));

        case 42:
          _context2.next = 53;
          break;

        case 44:
          isDefaultCardChanged = paymentMethods.lastActiveCardIndex !== filteredCardMethods.lastActiveCardIndex;
          activeCardMethod = filteredCardMethods.activeCardMethods.find(function (cardMethod) {
            return cardMethod.cardIndex === filteredCardMethods.lastActiveCardIndex;
          });
          _paymentData = { currencyCode: currencyCode, countryCode: countryCode, isDefaultCardChanged: isDefaultCardChanged };
          _context2.next = 49;
          return (0, _effects.put)((0, _actions.fetchPmtMethodsSucceded)(activeCardMethod, _paymentData));

        case 49:
          _context2.next = 51;
          return (0, _effects.put)((0, _actions.trackEvent)(_analytics.MESSAGE_TRACKING_QD_OPEN));

        case 51:
          _context2.next = 53;
          return (0, _messageBus.publish)(_events.MESSAGE_SUB_QD_OPENED, {});

        case 53:
          _context2.next = 59;
          break;

        case 55:
          _context2.prev = 55;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 59;
          return (0, _effects.put)((0, _actions.fetchPmtMethodsFailed)((0, _quickDepositLogic.uniformError)('APP_QD_ERR_NO_PMT_METHODS')));

        case 59:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 55]]);
}

/**
 * Resets the form
 * @returns {void}
 */
function reinitialiseForm() {
  var initValues;
  return _regenerator2.default.wrap(function reinitialiseForm$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.select)(_selectors.initialFormValuesSelector);

        case 2:
          initValues = _context3.sent;
          _context3.next = 5;
          return (0, _effects.put)((0, _immutable.initialize)(_constants.QD_RF_FORM_NAME, initValues));

        case 5:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

/**
 * Processes a failure on getting the customer's payment methods
 * @returns {void}
 */
function onFetchPmtFailed(_ref3) {
  var error = _ref3.error;
  return _regenerator2.default.wrap(function onFetchPmtFailed$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _messageBus.publish)(_events.MESSAGE_PUB_QD_FAIL, error);

        case 2:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

/**
 * Fetch watchFetchPmtMethods Saga
 * @returns {void}
 */
function watchFetchPmtMethods() {
  return _regenerator2.default.wrap(function watchFetchPmtMethods$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return takeEveryEffect(_constants.QD_ACTION_FETCH_PMT_METHODS, fetchPaymentMethods);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

/**
 * Fetch watchFetchPmtMethodsSucceded Saga
 * @returns {void}
 */
function watchFetchPmtMethodsSucceded() {
  return _regenerator2.default.wrap(function watchFetchPmtMethodsSucceded$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return takeEveryEffect(_constants.QD_ACTION_FETCH_PMT_METHODS_SUCCEDED, reinitialiseForm);

        case 2:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

/**
 * Fetch watchFetchPmtMethodsFailed Saga
 * @returns {void}
 */
function watchFetchPmtMethodsFailed() {
  return _regenerator2.default.wrap(function watchFetchPmtMethodsFailed$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return takeEveryEffect(_constants.QD_ACTION_FETCH_PMT_METHODS_FAILED, onFetchPmtFailed);

        case 2:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}